import { render, staticRenderFns } from "./ArticleImages.vue?vue&type=template&id=0b16a4aa&scoped=true"
import script from "./ArticleImages.vue?vue&type=script&lang=js"
export * from "./ArticleImages.vue?vue&type=script&lang=js"
import style0 from "./ArticleImages.vue?vue&type=style&index=0&id=0b16a4aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b16a4aa",
  null
  
)

export default component.exports